import consulting from './consulting';
import analysis from './data_analysis';
import outsourcing from './outsourcing';
// Add confirmed recent work here. Optional fields: summary, period, status, role.
export const recentProjects = [
  {
    "id": "recent-scrap-car",
    "img": "/images/recent-projects/scrap-car.webp",
    "logo": "/images/recent-projects/scrap-car.webp",
    "imageKind": "screenshot",
    "alt": "폐차 견적 조회 화면",
    "category": "플랫폼·웹 서비스",
    "title": "폐차 견적 앱·관리 시스템",
    "period": "2023 ~ 2025",
    "body": "차량번호를 통해 차량을 간편하게 조회하고 폐차 견적을 확인하는 서비스입니다. 모바일 앱과 관리 웹을 개발했습니다.",
    "summary": "차량번호를 통해 차량을 간편하게 조회하고 폐차 견적을 확인하는 서비스입니다.",
    "role": "전체 개발",
    "stack": "Flutter · React · AWS",
    "hashtag": [
      "#Flutter",
      "#React",
      "#App",
      "#Web",
      "#프론트엔드",
      "#인프라"
    ]
  },
  {
    "id": "recent-reptile-market",
    "img": "/images/recent-projects/reptile-market.webp",
    "logo": "/images/recent-projects/reptile-market.webp",
    "imageKind": "screenshot",
    "alt": "파충류 거래 프로젝트 대표 이미지",
    "category": "플랫폼·웹 서비스",
    "title": "파충류 거래·용품 쇼핑 플랫폼",
    "period": "2023 ~ 2024",
    "body": "다양한 종류의 파충류 거래와 관련 용품 쇼핑을 지원하는 플랫폼입니다. 모바일 앱과 서버를 포함한 서비스를 개발했습니다.",
    "summary": "다양한 종류의 파충류 거래와 관련 용품 쇼핑을 지원하는 플랫폼입니다.",
    "role": "전체 개발",
    "stack": "Flutter · Spring Boot · AWS",
    "hashtag": [
      "#Flutter",
      "#spring",
      "#App",
      "#백엔드",
      "#프론트엔드",
      "#인프라"
    ]
  },
  {
    "id": "recent-health-band",
    "img": "/images/recent-projects/health-monitoring.webp",
    "logo": "/images/recent-projects/health-monitoring.webp",
    "alt": "건강 모니터링 프로젝트의 생체신호 수집 및 데이터 처리 개념도",
    "category": "모바일 앱",
    "title": "스마트밴드 연동 건강 모니터링 앱",
    "period": "2023",
    "body": "스마트밴드에서 전달되는 신호를 연동하여 착용자의 건강 상태를 확인하는 모바일 앱입니다. 기립성 저혈압 관련 건강 모니터링을 위한 앱을 개발했습니다.",
    "summary": "스마트밴드에서 전달되는 신호를 연동하여 착용자의 건강 상태를 확인하는 모바일 앱입니다.",
    "role": "전체 개발",
    "stack": "Flutter",
    "hashtag": [
      "#Flutter",
      "#App",
      "#프론트엔드"
    ]
  },
  {
    "id": "recent-graduation-gallery",
    "img": "/images/recent-projects/namseoul-university.webp",
    "logo": "/images/recent-projects/namseoul-university.webp",
    "alt": "남서울대학교 로고",
    "category": "플랫폼·웹 서비스",
    "title": "졸업작품 온라인 전시·관리 페이지",
    "period": "2025",
    "body": "졸업작품을 연도별로 전시하고 관리하는 웹 페이지입니다. 여러 해의 작품을 구분하여 살펴볼 수 있는 전시·관리 페이지를 개발했습니다.",
    "summary": "졸업작품을 연도별로 전시하고 관리하는 웹 페이지입니다.",
    "role": "전체 개발",
    "stack": "HTML",
    "hashtag": [
      "#Web",
      "#프론트엔드"
    ]
  },
  {
    "id": "recent-pharmacy-payment",
    "img": "/images/recent-projects/medicoach.webp",
    "logo": "/images/recent-projects/medicoach.webp",
    "imageTheme": "dark",
    "alt": "메디코치 로고",
    "category": "플랫폼·웹 서비스",
    "title": "약국 구독 서비스 결제 기능 고도화",
    "period": "2024",
    "body": "의약품 구독 서비스의 결제 기능과 연계 업무 흐름을 개선했습니다. Android·iOS 앱, 관리자 웹, 약국 웹에 걸친 결제 관련 기능과 프로세스를 수정했습니다.",
    "summary": "의약품 구독 서비스의 결제 기능과 연계 업무 흐름을 개선했습니다.",
    "role": "기존 서비스의 결제 기능 및 연계 프로세스 개선",
    "stack": "Android Native · Swift",
    "hashtag": [
      "#App",
      "#Web",
      "#Android",
      "#프론트엔드"
    ]
  },
  {
    "id": "recent-virtual-land",
    "img": "/images/recent-projects/virtual-land.webp",
    "logo": "/images/recent-projects/virtual-land.webp",
    "imageKind": "screenshot",
    "alt": "가상 토지 거래 프로젝트 대표 이미지",
    "category": "플랫폼·웹 서비스",
    "title": "국내 지역 기반 가상 토지 거래 플랫폼",
    "period": "2024",
    "body": "한국의 지역을 기반으로 구성한 가상 토지를 사고파는 플랫폼입니다. 가상 토지 매매를 위한 웹 서비스를 개발했습니다.",
    "summary": "한국의 지역을 기반으로 구성한 가상 토지를 사고파는 플랫폼입니다.",
    "role": "전체 개발",
    "stack": "React · Oracle · Ubuntu",
    "hashtag": [
      "#React",
      "#Web",
      "#프론트엔드",
      "#백엔드",
      "#인프라"
    ]
  }
];
const categories = { '컨설팅': '컨설팅·아키텍처', '데이터분석': '데이터 분석' };
export const projects = [...consulting, ...analysis, ...outsourcing, ...recentProjects].map(p => ({...p, category: categories[p.category] || p.category, summary: p.summary || p.body.trim().split('\n')[0]}));
export const projectCategories = ['컨설팅·아키텍처', '데이터 분석', '모바일 앱', '플랫폼·웹 서비스', '업무 시스템·서비스 연동'].filter(category => projects.some(p => p.category === category));
